class VanillaContactFormComplete {
  constructor(options = {}, root = document) {
    this.root = root;

    this.targetSelector = options.targetSelector || "#js-page-contact";
    this.closeSelector = options.closeSelector || "#js-modal-close";
    this.formSelector = options.formSelector || ".wpcf7-form";

    this.completeClass = options.completeClass || "--form-complete";
    this.modalEndClass = options.modalEndClass || "--form-modal-end";

    this.closeDelay = options.closeDelay || 1000;
    this.closeTimer = null;

    this.handleMailSent = this.handleMailSent.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.init();
  }

  init() {
    const target = this.getTarget();

    if (!target) return;

    this.initContactForm7();

    document.addEventListener("wpcf7mailsent", this.handleMailSent, false);
    document.addEventListener("click", this.handleClick, false);
  }

  initContactForm7() {
    const forms = this.getForms();

    if (!forms.length) return;

    forms.forEach((form) => {
      /**
       * Contact Form 7 v5.4以降
       */
      if (window.wpcf7 && typeof window.wpcf7.init === "function") {
        window.wpcf7.init(form);
        return;
      }

      /**
       * 古いContact Form 7用の保険
       */
      if (window.wpcf7 && typeof window.wpcf7.initForm === "function") {
        window.wpcf7.initForm(form);
      }
    });
  }

  getForms() {
    if (this.root && typeof this.root.querySelectorAll === "function") {
      return Array.from(this.root.querySelectorAll(this.formSelector));
    }

    return Array.from(document.querySelectorAll(this.formSelector));
  }

  getTarget() {
    if (this.root && typeof this.root.querySelector === "function") {
      return this.root.querySelector(this.targetSelector);
    }

    return document.querySelector(this.targetSelector);
  }

  handleMailSent(event) {
    const target = this.getTarget();

    if (!target) return;

    /**
     * Barba遷移中に別containerのCF7イベントを拾わないための保険
     */
    if (
      this.root !== document &&
      event.target &&
      !this.root.contains(event.target)
    ) {
      return;
    }

    this.clearCloseTimer();

    target.classList.remove(this.modalEndClass);
    target.classList.add(this.completeClass);
  }

  handleClick(event) {
    const closeButton = event.target.closest(this.closeSelector);

    if (!closeButton) return;

    const target = this.getTarget();

    if (!target) return;

    /**
     * Barba遷移中に別containerのクリックを拾わないための保険
     */
    if (this.root !== document && !this.root.contains(closeButton)) {
      return;
    }

    this.clearCloseTimer();

    target.classList.add(this.modalEndClass);

    this.closeTimer = window.setTimeout(() => {
      target.classList.remove(this.completeClass);
      target.classList.remove(this.modalEndClass);

      this.closeTimer = null;
    }, this.closeDelay);
  }

  clearCloseTimer() {
    if (!this.closeTimer) return;

    window.clearTimeout(this.closeTimer);
    this.closeTimer = null;
  }

  destroy() {
    this.clearCloseTimer();

    document.removeEventListener("wpcf7mailsent", this.handleMailSent, false);
    document.removeEventListener("click", this.handleClick, false);
  }
}

export default VanillaContactFormComplete;
